import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

interface ListingProps {
  search: string;
  pageNo: number;
}

const GetOrganizationsListService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.organization.list +
      `?search=${payload.search}&pageNo=${payload.pageNo}`
  );
};

const AddOrganizationService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.organization.add, payload);
};

const GetOrganizationDetailService = (id: string) => {
  return HTTP_CLIENT.get(
    Endpoint.organization.getSingleOrganization.replace(":id", id)
  );
};

const EditOrganizationService = (payload: any, id: string) => {
  return HTTP_CLIENT.put(
    Endpoint.organization.edit.replace(":id", id),
    payload
  );
};

const DeleteOrganizationService = ({ id }: { id: string }) => {
  return HTTP_CLIENT.delete(Endpoint.organization.delete.replace(":id", id));
};

const ActivateOrganizationService = ({ id }: { id: string }) => {
  return HTTP_CLIENT.put(Endpoint.organization.activate.replace(":id", id));
};

const DisableOrganizationService = ({ id }: { id: string }) => {
  return HTTP_CLIENT.put(Endpoint.organization.disable.replace(":id", id));
};

export {
  GetOrganizationsListService,
  AddOrganizationService,
  DeleteOrganizationService,
  EditOrganizationService,
  GetOrganizationDetailService,
  ActivateOrganizationService,
  DisableOrganizationService,
};
